import React, { createContext, useEffect, useState } from 'react';
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import { ENDPOINT_COMPONENT } from '../Config';
import { useNavigate, useParams } from 'react-router-dom';
import eventTypes from "../data/event_types.json";
import useProps from '../hooks/useProps';

const EventContext = createContext({});

export const EventProvider = ({ children }) => {
    const { groupId } = useParams();
    const axiosPrivate = useAxiosPrivate();
    const { setProps } = useProps();
    const [group, setGroup] = useState(null);
    const [event, setEvent] = useState({});
    const [eventLoading, setEventLoading] = useState(false);
    const navigate = useNavigate();

    const loadEvent = async () => {
        try {
            setEventLoading(true);
            // console.log('loadGroup :>> ', group);
            const response = await axiosPrivate.get(ENDPOINT_COMPONENT.replace('{groupId}', group), {});
            // console.log('loadGroup :>> ', response.data);
            if (response?.data?.archived) {
                navigate(`/`);
                return;
            }
            setEvent(response.data);
        } catch (error) {
            console.error('loadEvent', error);
            navigate(`/`);
        } finally {
            setEventLoading(false);
        }
    }

    const switchGroup = (newGroupId) => {
        setGroup(newGroupId);
    };

    useEffect(() => {
        setGroup(groupId);
    }, []);

    useEffect(() => {
        const type = eventTypes.find(t => t.value === event.eventType);
        if (type) {
            setProps(type.props);
        }
    }, [event]);

    useEffect(() => {
        if (group) {
            loadEvent();
        }
    }, [group]);

    return (
        <>
            {eventLoading ?
                <p>Loading...</p>
                :
                <EventContext.Provider value={{ event, setEvent, switchGroup }}>
                    {children}
                </EventContext.Provider>
            }
        </>
    );
};
export default EventContext;